module.exports = __webpack_public_path__ + "d8e3bbb05aa228ef7591ec6b2a9b5154.svg";